<!-- eslint-disable max-len -->
<template>
<svg
    width="32" height="32" viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
>
    <path
        d="M16 20.0007V26.6673C16 26.6673 20.04 25.934 21.3333 24.0007C22.7733 21.8407 21.3333 17.334 21.3333 17.334"
        stroke="currentColor" stroke-width="2.25"
        stroke-linecap="round" stroke-linejoin="round"
    />
    <path
        d="M6.00065 21.9965C4.00065 23.6765 3.33398 28.6632 3.33398 28.6632C3.33398 28.6632 8.32065 27.9965 10.0007 25.9965C10.9473 24.8765 10.934 23.1565 9.88065 22.1165C9.36239 21.6219 8.67971 21.336 7.96362 21.3139C7.24753 21.2917 6.54849 21.5348 6.00065 21.9965Z"
        stroke="currentColor" stroke-width="2.25"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
    <path
        d="M12 15.9997C12.7095 14.1589 13.6029 12.3944 14.6667 10.733C16.2202 8.249 18.3835 6.20374 20.9507 4.7918C23.5178 3.37986 26.4036 2.64817 29.3333 2.66635C29.3333 6.29301 28.2933 12.6663 21.3333 17.333C19.649 18.3976 17.8623 19.2909 16 19.9997L12 15.9997Z" stroke="currentColor" stroke-width="2.25"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
    <path
        d="M12.0007 16.0034H5.33398C5.33398 16.0034 6.06732 11.9634 8.00065 10.67C10.1607 9.23004 14.6673 10.7367 14.6673 10.7367"
        stroke="currentColor" stroke-width="2.25"
        stroke-linecap="round" stroke-linejoin="round"
    />
</svg>
</template>
